import React from 'react';
import classNames from 'classnames';
import './styles.scss';

export type SourceTone = 'app' | 'brew' | 'npm' | 'editor' | 'py' | 'go' | 'rust' | 'binary' | 'mcp' | 'default';

interface SourcePillProps {
    label: string;
    icon?: React.ReactNode;
    tone?: SourceTone;
    title?: string;
}

/**
 * A compact rounded label for an inventory source / package type. Presentational
 * only — the caller resolves the friendly label, icon, and tone (see `sourceMeta`).
 */
const SourcePill: React.FC<SourcePillProps> = ({ label, icon, tone = 'default', title }) => (
    <span className={classNames('rb-source-pill', `rb-source-pill--${tone}`)} title={title ?? label}>
        {icon && <span className="rb-source-pill__icon">{icon}</span>}
        <span className="rb-source-pill__label">{label}</span>
    </span>
);

export default SourcePill;
